import { logger } from "./logger";
import { getUserManager } from '../../config/auth.config';
import { medsUserApi } from "../../services/medicationmanagement/medsUser/MedsUserApi";
import { SignOutEventLog } from "../../services/medicationmanagement/medsUser/models/SignOutEventLog";

export const handleSignOut = async (props: { reason: string; url: string }) => {
  logger.log("Start logging out");
  let userManager = getUserManager();
  let user = await userManager.getUser();
  let userInfo = await user?.profile;  
  let signOutEventLog: SignOutEventLog = {
    email: userInfo?.emails[0],
    givenName: userInfo?.given_name,
    familyName: userInfo?.family_name,
    url: props.url,
    ipAddress: "",
    reason: props.reason,
  };
  try {
    await medsUserApi.singOutEvenLog(signOutEventLog);
    logger.log("logout event triggered");
  }
  finally {
    logger.log("redirecting to logout");
    window.localStorage.clear();
    await userManager.signoutRedirect();
  }
};
